import React from "react";
import Logo from "../images/dsb_white_transparent.png";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div className="navbar__fixed__ui">
      <div className="navbar__layout" id="top__page">
        <Link to="/">
          <div className="logo__layout">
            <img src={Logo} className="logo__size" />
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
